import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Layout } from '../../components/Layout';
import Content from './Content';
import { Tabs } from './types';
import PeriodProfitChart from '../Detail/Charts/PeriodProfitChart';
import {
  ProfitByPeriodApiResponse,
  ProfitCalculationProfitData,
} from '../Detail/Charts/types';

interface PassedProps {
  tab: Tabs;
}

const ProfitCalculations = () => {
  const { state: passedProps }: { state: PassedProps | undefined } =
    useLocation();

  const [activeTab, setActiveTab] = useState(
    passedProps?.tab || Tabs.LiveCPCDaemon,
  );
  const [profitByPeriodData, setProfitByPeriodData] = useState<
    ProfitByPeriodApiResponse | undefined
  >();
  const [profitData, setProfitData] = useState<
    ProfitCalculationProfitData | undefined
  >();

  const actions = [
    Tabs.LiveCPCDaemon,
    Tabs.CalculationResultHistory,
    Tabs.ComplexParamsCalcultion,
    Tabs.SingleProfitCalculation,
    Tabs.Candles,
  ];

  const profits = [
    { label: 'Total Stable Profit', delta: profitData?.stable },
    { label: 'Total Asset Profit', delta: profitData?.asset },
    { label: 'Total Price Change', delta: profitData?.price },
    {
      label: 'Total Price Change Since First Transaction',
      delta: profitData?.priceSinceFirstTransaction,
    },
  ];

  return (
    <Layout>
      <Layout.SideMenu>
        <Layout.SideMenuSection>
          <Layout.SideMenuTitle title="Actions" count={actions.length} />
          <>
            {actions.map((action) => (
              <Layout.SideMenuItem
                key={action}
                id={action}
                label={action}
                onClick={setActiveTab}
                isActive={activeTab === action}
              />
            ))}
          </>
        </Layout.SideMenuSection>

        {profitData && activeTab !== Tabs.Candles ? (
          <Layout.SideMenuSection>
            <Layout.SideMenuTitle title="Profit" count={profits.length} />
            <>
              {profits.map((profit) => (
                <Layout.SideMenuItem
                  key={profit.label}
                  id={profit.label}
                  label={profit.label}
                  delta={profit.delta}
                />
              ))}
            </>
            <PeriodProfitChart data={profitByPeriodData} />
          </Layout.SideMenuSection>
        ) : undefined}
      </Layout.SideMenu>
      <Layout.Content>
        <Content
          activeTab={activeTab}
          setProfitByPeriodData={setProfitByPeriodData}
          setProfitData={setProfitData}
        />
      </Layout.Content>
    </Layout>
  );
};

export default ProfitCalculations;
